export default "__VITE_ASSET__DQ1FDO6R__"